import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/pcRoListCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customPrCorSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getgrdList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		/*날짜 포멧변환*/
		var strtMm01, endMm01, strtMm02, endMm02;

		if (searchParams.strtMm01) {
			strtMm01 = moment(searchParams.strtMm01).format('YYYYMMDD');
		} else {
			strtMm01 = '';
		}
		if (searchParams.endMm01) {
			endMm01 = moment(searchParams.endMm01).format('YYYYMMDD');
		} else {
			endMm01 = '';
		}
		if (searchParams.strtMm02) {
			strtMm02 = moment(searchParams.strtMm02).format('YYYYMMDD');
		} else {
			strtMm02 = '';
		}
		if (searchParams.endMm02) {
			endMm02 = moment(searchParams.endMm02).format('YYYYMMDD');
		} else {
			endMm02 = '';
		}
		if (searchParams.srchMm01 !== undefined) {
			queryStr = objectToQuerystring({
				//htwoCorp: searchParams.htwoCorp, //생산법인
				//plntCd: searchParams.plntCd, //생산공장
				carScn: searchParams.carScn, //차량구분
				srchMm01: searchParams.srchMm01, //판매월
				pacScn: searchParams.pacScn, //승상구분
				srchMm02: searchParams.srchMm02, //조건월
				partNo: searchParams.partNo, //품번
				roNo: searchParams.roNo, //RO No
				prtlSbc: searchParams.prtlSbc, //특이사항검색
				strtTotCst: searchParams.strtTotCst, //비용(from)
				endTotCst: searchParams.endTotCst, //비용(to)
				//saleNat: searchParams.saleNat, //판매국가
				saleRegn: searchParams.saleRegn, //판매지역
				flclSpc: searchParams.flclSpc, //연료전지사양
				cType: searchParams.cType, //클레임타입
				phmnCd: searchParams.phmnCd, //현상코드
				opCd: searchParams.opCd, //작업코드
				cmpnNo: searchParams.cmpnNo, //캠페인번호
				prcStepGb: searchParams.prcStepGb, //처리단계
				prcRsltCd: searchParams.prcRsltCd, //처리결과
				partType: searchParams.partType, //부품유형
				idxScn: searchParams.idxScn, //지수구분
				ceqType: searchParams.ceqType, //정비유형
				useTerm: searchParams.useTerm, //사용기간
				carTypeNm: searchParams.carTypeNm, //차종유형
				check: searchParams.check, //누적
				m3IdxScn: searchParams.m3IdxScn,

				strtMm01: strtMm01, //strtMm01
				endMm01: endMm01, //endMm01
				strtMm02: strtMm02, //strtMm02
				endMm02: endMm02, //endMm02
				currentPage,
				pageUnit
			});
		}
		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/clma/pcClamRo/v1/pcClamRoList` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
